import { Component, EventEmitter, Input, Output, OnInit, computed, Signal, input } from '@angular/core';
import { ApplicationGroup, AppText } from '../interfaces/common';

@Component({
  selector: 'app-switch-application',
  templateUrl: './switch-application.component.html',
  styleUrls: ['./switch-application.component.css']
})
export class SwitchApplicationComponent implements OnInit {

  @Input() selText: AppText = {};
  @Input() allApplications: any[] = [];
  @Input() activateSwitchApplication: boolean = false;  // Is true when switchView is clicked and visible in app
  @Input() currentApplication: string = "";
  apps = input<ApplicationGroup[]>([]);

  // We are using the URL as a kind of id. Its read in app.component during init time, transform it to only be the searchParams.
  @Input({transform: (url: string) => {
    const urlObj = new URL(url)
    return urlObj.search
  }}) currentURLSearchParams: string = "";

  appsFiltered: Signal<ApplicationGroup[]> = computed(() => {
    const apps: ApplicationGroup[] = this.apps()
    if (!apps || apps?.length === 0) return []
    if (this.currentURLSearchParams === "") return apps
    return apps.filter((app: ApplicationGroup) => {
      const appURLSearchParams: string = "?" + (app?.url?.split("?")?.[1] ?? "")
      //console.log(appURLSearchParams)
      //console.log(this.currentURLSearchParams)
      //Filter out non-published apps and the current app we are currently in
      return app?.availability === "published" && this.currentURLSearchParams !== appURLSearchParams
    })

  })

  @Output() updateSwitchApplication = new EventEmitter();

  constructor( ) { }

  ngOnInit(): void {
    // Deliberately empty
  }

  switchApplication(url: string): void {
    window.open(url, "_self");
  }

  closeSwitchApplication(): void {
    this.activateSwitchApplication = false;
    this.updateSwitchApplication.emit(false)
  }
}